import React, { useEffect, useState } from "react";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import CustomLogisticsTable from "../../CustomLogisticsTable";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import updateIcon from "../../../../../Assets/icons/check-circle (8) 1.svg";
import DetailsTable from "./DetailsTable";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import { showCustomAlert } from "../../../../customComponents/CustomSweetAlert";
import Loader from "../../../../customComponents/CustomLoader";


const PoApprovalDetails = () => {
  const [poApprovalEdit, setPoApprovalEdit] = useState([]);
  const [poId, setPoId] = useState(0);
  const [formData, setFormData] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true)
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [editRowId, setEditRowId] = useState(null); 
  const [editedQuantity, setEditedQuantity] = useState({}); 
  const [editRow, setEditRow] = useState(null);
  const [productdetails, setProductDetails] = useState([]);
  const token = localStorage.getItem("authToken");
  const [vendorId, setVendorId] = useState(); 
  const navigate = useNavigate()
  const location = useLocation();
  const { data } = location.state || {};
  const PhysicalStockinId = data?.phystkin_id;
  console.log("locationdata<><><>", data);

  useEffect(() => {
    fetchPoApprovalDetailsEdit();
  }, []);

  const fetchPoApprovalDetailsEdit = async () => {
    try {
      setLoading(true)
      const response = await axiosInstance.get(
        `/purchaseorder/edit/${data.po_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data;

      console.log(fetchedData, "FETCHEDDATA");
      setPoApprovalEdit(fetchedData);
      const poIdVal = response.data.data.po_id;
      console.log(poIdVal, "POVALID");
      setPoId(poIdVal);

      console.log(formData, "depatartment DATA");
    } catch (error) {
      console.log(error);
    }
    finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    if (poId !== 0) {
      fetchProductDetails();
    }
  }, [poId]);

  const fetchProductDetails = async (page = 0, pageSize = 5) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        "/podetails/list",
        {
          po_id: poId,
          orderBy: "po_details_id asc",
          page,
          pageSize,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data;

      console.log(formattedData, "formatdata");
      setProductDetails(formattedData);

      const quantities = formattedData.map((item) => item.po_details_id);
      console.log(quantities, "QuantValues");

      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalRecords(totalRecordsData);

      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
    finally{
      setLoading(false)
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProductDetails(newPage);
  };




  const DEPARTMENT_TABLE_HEADERS = [
    // "Sr No.",
    // "Department ID",
    "Name",
    "Logistic Type",
    "Product Name",
    "Sub Product Name",
    "Make Name",

    "Variant Name",
    "Quantity",
    "Quantity Approved",
    "Price",
    "Tax",
    "Taxset Amount",
    "Total Price",
    "Action",
  ];

  const DEPARTMENT_KEY_MAPPING = {
    Name: "name",
    "Logistic Type": "itemtypename",
    "Product Name": "product_name",
    "Sub Product Name": "subproduct_name",
    "Make Name": "make_name",
    "Model Name": "model_name",
    "Variant Name": "variant_name",
    Quantity: "quantity",
    "Quantity Approved": "qty_approved",
    Price: "rate",
    Tax: "tax",
    "Taxset Amount": "taxset_amount",
    "Total Price": "totalprice",
   'Action': [
      {
        type: 'edit',
        label: 'Edit',
        icon: editIcon,
      },
      
     
    ]
  };
 
  const handleEditClick = (row) => {
    console.log(row.po_details_id, "row");
   setEditRow(row.po_details_id)
    setEditRowId(row.po_details_id); // Set the specific row in edit mode
    setEditedQuantity({ [row.po_details_id]: row.qty_approved }); // Initialize with the current quantity for the specific row
  };
  // const handleQuantityChange = (e, rowId) => {
  //   const newQuantity = e.target.value; // Capture the input as a string

  //   if (
  //     newQuantity === "" ||
  //     isNaN(newQuantity) ||
  //     parseInt(newQuantity) <= 0
  //   ) {
  //     // Handle invalid input case
  //     console.warn("Invalid quantity input:", newQuantity);
  //     setEditedQuantity({ ...editedQuantity, [rowId]: newQuantity }); // Still update the state with the current input
  //     return;
  //   }

  //   // Convert the input to an integer after validation
  //   const validQuantity = parseInt(newQuantity, 10);

  //   // Find the row in productdetails to calculate new values
  //   const rowToUpdate = productdetails.find(
  //     (item) => item.po_details_id === rowId
  //   );
  //   console.log(rowToUpdate, "ROWTOUPDATE");

  //   if (rowToUpdate) {
  //     const rate = parseFloat(rowToUpdate.rate) || 0; // Convert to float, default to 0 if NaN
  //     console.log("rate",rate);
      
  //     const tax = parseFloat(rowToUpdate.tax)/100 || 0; // Convert to float, default to 0 if NaN

  //     // Recalculate the total price and tax amount
  //     const total = validQuantity * rate;
  //     console.log(total, "TOTALVALUE");
  //     const taxAmountValue = total * tax;

  //     const newTaxAmount = taxAmountValue;
  //     const newTotalPrice = newTaxAmount + total;

  //     // Update the state with the new calculated values
  //     setProductDetails((prevDetails) =>
  //       prevDetails.map((item) =>
  //         item.po_details_id === rowId
  //           ? {
  //               ...item,
  //               qty_approved: validQuantity,
  //               totalprice: newTotalPrice,
  //               taxset_amount: newTaxAmount,
  //             }
  //           : item
  //       )
  //     );

  //     setEditedQuantity({ ...editedQuantity, [rowId]: validQuantity }); // Update the quantity for the specific row
  //   }
  // };

  const cleanAmount = (amount) => {
    if (typeof amount === 'string') {
      return parseFloat(amount.replace(/[₹,]/g, '').trim()) || 0;
    }
    return amount; // If it's already a number, return it as-is
  };
  const handleQuantityChange = (e, rowId) => {
    const newQuantity = e.target.value; // Capture the input as a string
  
    if (
      newQuantity === "" ||
      isNaN(newQuantity) ||
      parseInt(newQuantity) <= 0
    ) {
      // Handle invalid input case
      console.warn("Invalid quantity input:", newQuantity);
      setEditedQuantity({ ...editedQuantity, [rowId]: newQuantity }); // Still update the state with the current input
      return;
    }
  
    // Convert the input to an integer after validation
    const validQuantity = parseInt(newQuantity, 10);
  
    // Find the row in productdetails to calculate new values
    const rowToUpdate = productdetails.find(
      (item) => item.po_details_id === rowId
    );
    console.log(rowToUpdate, "ROWTOUPDATE");
  
    if (rowToUpdate) {
      // Clean and convert the rate and any other amounts using the cleanAmount function
      const rate = cleanAmount(rowToUpdate.rate); // Using cleanAmount
      const tax = cleanAmount(rowToUpdate.tax) / 100; // Convert tax to decimal format
  
      console.log("rate", rate);
  
      // Recalculate the total price and tax amount
      const total = validQuantity * rate;
      console.log(total, "TOTALVALUE");
      const taxAmountValue = total * tax;
  
      const newTaxAmount = taxAmountValue;
      const newTotalPrice = newTaxAmount + total;
  
      // Update the state with the new calculated values
      setProductDetails((prevDetails) =>
        prevDetails.map((item) =>
          item.po_details_id === rowId
            ? {
                ...item,
                qty_approved: validQuantity,
                totalprice: newTotalPrice,
                taxset_amount: newTaxAmount,
              }
            : item
        )
      );
  
      setEditedQuantity({ ...editedQuantity, [rowId]: validQuantity }); // Update the quantity for the specific row
    }
  };
  
  // Utility function to clean amount by removing symbols and commas
// const cleanAmount = (amount) => {
//   if (typeof amount === 'string') {
//     return parseFloat(amount.replace(/[₹,]/g, '').trim()) || 0;
//   }
//   return amount; // If it's already a number, return it as-is
// };

const handleSave = async (row) => {
  console.log(
    "Saving Quantity for row:",
    row.po_details_id,
    "New Quantity:",
    editedQuantity[row.po_details_id]
  );

  const rowToUpdate = productdetails.find(
    (item) => item.po_details_id === row.po_details_id
  );

  if (rowToUpdate) {
    const newQuantity = editedQuantity[row.po_details_id];

    // Clean and convert the rate and tax using the cleanAmount function
    const rate = cleanAmount(rowToUpdate.rate); // Clean the rate
    const tax = cleanAmount(rowToUpdate.tax) / 100; // Clean and convert tax to decimal

    // Recalculate the total price and tax amount
    const total = newQuantity * rate;
    const taxAmountValue = total * tax;
    const newTaxAmount = taxAmountValue;
    const newTotalPrice = newTaxAmount + total;

    // Prepare payload for saving
    const payload = {
      qty_approved: newQuantity,
      totalprice: String(newTotalPrice), // Convert to string for consistency
      taxset_amount: String(newTaxAmount), // Convert to string for consistency
    };

    try {
      const response = await axiosInstance.patch(
        `/purchaseorderapproval/update/${row.po_details_id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response, "EDITQUANTRESPONSE");
      if(response.status===200){
        fetchProductDetails();
      }
      // Update productdetails state with new values
      setProductDetails((prevDetails) =>
        prevDetails.map((item) =>
          item.po_details_id === row.po_details_id
            ? {
                ...item,
                qty_approved: newQuantity,
                totalprice: newTotalPrice,
                taxset_amount: newTaxAmount,
              }
            : item
        )
      );
    } catch (error) {
      console.log(error);
    }

    // After saving, reset the edit state
    setEditRowId(null);
  }
};

  
  // const handleSave = async (row) => {
    
  //   console.log(
  //     "Saving Quantity for row:",
  //     row.po_details_id,
  //     "New Quantity:",
  //     editedQuantity[row.po_details_id]
  //   );

  //   const rowToUpdate = productdetails.find(
  //     (item) => item.po_details_id === row.po_details_id
  //   );

  //   if (rowToUpdate) {
  //     const newQuantity = editedQuantity[row.po_details_id];

  //     const total = newQuantity * rowToUpdate.rate;
  //     const taxAmountValue = total * (rowToUpdate.tax)/100;
  //     const newTaxAmount = taxAmountValue;
  //     const newTotalPrice = newTaxAmount + total;

  //     // Prepare payload for saving
  //     const payload = {
  //       qty_approved: newQuantity,
  //       totalprice: String(newTotalPrice),
  //       taxset_amount: String(newTaxAmount),
  //     };

  //     try {
  //       const response = await axiosInstance.patch(
  //         `/purchaseorderapproval/update/${row.po_details_id}`,
  //         payload,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );
  //       console.log(response, "EDITQUANTRESPONSE");

  //       setProductDetails((prevDetails) =>
  //         prevDetails.map((item) =>
  //           item.po_details_id === row.po_details_id
  //             ? {
  //                 ...item,
  //                 qty_approved: newQuantity,
  //                 totalprice: newTotalPrice,
  //                 taxset_amount: newTaxAmount,
  //               }
  //             : item
  //         )
  //       );
  //     } catch (error) {
  //       console.log(error);
  //     }

  //     // After saving, reset the edit state
  //     setEditRowId(null);
  //   }
  // };

  // const handleApprove = async () => {
  //   try {
  //     const payload = {
  //       is_approved: 1,
  //     };

  //     const response = await axiosInstance.patch(
  //       `/purchaseorderapproval/updatePoapproval/${data.po_id}`,
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //       navigate(ROUTES_NAVIGATION.POAPPROVAL)
  //     console.log(response, "RESPONSE");
  //   } catch (error) {
  //     console.log(error, "error");
  //   }
  // };

  const handleApprove = async () => {
    // SweetAlert confirmation before approval
    showCustomAlert({
      title: "Success",
      text: "Do you want to approve this purchase order?",
      icon: "success",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      callback: async () => {
        try {
          const payload = {
            is_approved: 1,
          };
  
          // API request to approve purchase order
          const response = await axiosInstance.patch(
            `/purchaseorderapproval/updatePoapproval/${data.po_id}`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
  
          // Success action if approval is successful
          if (response.status === 200) {
            navigate(ROUTES_NAVIGATION.POAPPROVAL);
            console.log(response, "RESPONSE");
          }
        } catch (error) {
          console.log(error, "error");
  
          // Error handling with SweetAlert
          showCustomAlert({
            title: "Error",
            text: "Failed to approve the purchase order. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
    });
  };
  

  return (
    <div>
    {loading ? (
      <Loader />
    ) : (
    <div>
      <div className="">
        <div
          style={{
            paddingBottom: "35px",
            borderBottom: "1px solid lightgray",
            padding: "35px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <span
              style={{
                fontWeight: "300",
                fontSize: "12px",
                paddingBottom: "5px",
                color: "gray",
                paddingLeft: "15px",
              }}
            >
              Logistics / PO Approval / PO Approval Details
            </span>
            <div className="backbutton" onClick={()=>navigate(-1)}>
              <img src={backicon} alt="back" />
              <span className="backbtntitleDetails"> PO Approval Details</span>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            {/* <button
              className="clear-btn"
              style={{
                padding: "12px 28px",
                borderRadius: "38px",
                color: "green",
              }}
            >
              Back
            </button> */}
            <button
              className="flte-btn"
              style={{ padding: "12px 18px", borderRadius: "38px" }}
              onClick={handleApprove}
            >
              Approve
            </button>
          </div>
        </div>

        <div>
          <div className="">
            <h5
              style={{ paddingLeft: "55px" }}
              className="mt-2 mb-2 header-details"
            >
              Purchase Order
            </h5>
            <div
              className="detail-grid"
              style={{
                paddingBottom: "30px",
                borderBottom: "1px solid lightgray",
                paddingLeft: "57px",
                paddingTop: "15px",
              }}
            >
              <div className="details-item">
                <span className="details-label">PO Number</span>
                <span className="details-value">
                  {" "}
                  {poApprovalEdit.po_number}{" "}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">PO Date</span>
                <span className="details-value">{poApprovalEdit.po_date} </span>
              </div>
              <div className="details-item">
                <span className="details-label">Purchase Order Type</span>
                <span className="details-value">{poApprovalEdit.po_type} </span>
              </div>
              <div className="details-item">
                <span className="details-label">Vendor Name</span>
                <span className="details-value">
                  {poApprovalEdit.companyname}{" "}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Ref. No.</span>
                <span className="details-value">
                  {poApprovalEdit.reference_no}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Department</span>
                <span className="details-value">
                  {poApprovalEdit.department_name}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Payment Term</span>
                <span className="details-value">
                  {poApprovalEdit.payment_term_name}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Payment Type</span>
                <span className="details-value">
                  {poApprovalEdit.payment_mode}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">PO Expected Date</span>
                <span className="details-value">
                  {poApprovalEdit.po_expected_date}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Payment Date</span>
                <span className="details-value">
                  {poApprovalEdit.payment_date}{" "}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Total</span>
                <span className="details-value">{poApprovalEdit.total} </span>
              </div>
            </div>

            <div style={{ paddingTop: "14px" }}>
              <DetailsTable
                data={productdetails}
                headers={DEPARTMENT_TABLE_HEADERS}
                keyMapping={DEPARTMENT_KEY_MAPPING}
                itemsPerPage={10}
                onPageChange={handlePageChange}
                handleEditClick={handleEditClick}
                handleQuantityChange={handleQuantityChange}
                handleSave={handleSave}
                editRowId={editRowId}
                setEditRowId={setEditRowId}
                editedQuantity={editedQuantity}
                setEditedQuantity={setEditedQuantity}
                updateIcon={updateIcon}

              />
            </div>
          </div>
        </div>
      </div>
      </div>
    )}
    </div>
  );
};

export default PoApprovalDetails;
